import debounce from "lodash.debounce";

export default {
  name: 'GoSearchComp',
  props: {
    filteredReadings: {
      type: Array,
      required: true
    },
    exitGoSearch: {
      type: Function,
      required: true
    },
    navigate: {
      type: Function,
      required: true
    },
    currentNumbering: { //of record loaded
      type: Number,
      default: -1
    },
    lastIndex: { //last index (numbering) of recor before go search
      type: Number,
      default: -1
    },
    navigateAfterSearch: {
      type: Boolean,
      default: true
    },
    showActionButtons: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      goSearch: '',
      goSearchResults: [],
    }
  },
  computed: {
    disableGoActionButtons: function () {
      return !this.goSearch || this.goSearchResults.length == 0;
    },
    goSearchLocation: function () {
      if (this.currentNumbering && this.currentNumbering < 0)
        return this.goSearchResults.length;

      let indx = this.goSearchResults.findIndex(r => r.numbering == this.currentNumbering) + 1;
      return `${indx} / ${this.goSearchResults.length}`;
    },
  },
  watch: {
    goSearch: function (value) {
      this.debouncedGoSearchFunc(value);
    },
  },
  created() {
    this.debouncedGoSearchFunc = debounce((value) => {
      this.goSearchTrimReadings(value);
    }, 500);
  },
  mounted() {
    this.$setFocusToElement('go_search_input', 500);

    //setTimeout(() => {
    //  this.$scrollToElement('main_gui_for_reading');
    //}, 2000);
  },
  beforeUnmount() {
    this.debouncedGoSearchFunc.cancel();
  },
  methods: {
    scrollToElement(elem, param = null) {
      if (!elem)
        return;

      if (param == null)
        param = { behavior: "smooth", block: "start", inline: "center", };

      let element = document.getElementById(elem);

      if (element)
        element.scrollIntoView(param);
    },
    goSearchTrimReadings() {
      this.goSearch = this.goSearch.trim();
      this.goSearchResults = [];

      if (!this.goSearch) {
        return;
      }

      const numOfDials = this.goSearch.length;

      this.goSearchResults = this.filteredReadings.filter(r => {
        if (!r.meterRef)
          return false;

        return r.meterRef.substring(r.meterRef.length - numOfDials) == this.goSearch;
      });
      if (this.goSearchResults.length > 0) {
        this.goSearchResults.sort((a, b) => a.numbering < b.numbering);
        this.goSearchNavIndex = -1;
      }

      if (this.navigateAfterSearch)
        this.goSearchFunc();
    },
    goSearchFunc() {
      if (this.goSearchResults.length == 0) {
        this.goSearchNavIndex = this.lastIndex;
      }

      let arr = this.goSearchResults.filter(r => r.numbering > this.goSearchNavIndex);

      if (arr && arr.length > 0)
        this.goSearchNavIndex = arr[0].numbering;
      else
        this.goSearchNavIndex = this.goSearchResults[0].numbering;

      if (this.goSearchNavIndex >= 0)
        this.navigate(this.goSearchNavIndex, false);
    },
  }
}
